// src/api/userApi.js
import AxiosInstance from "./API/AxiosInstance";

// Get all users
export const getProperties = async () => {
  const response = await AxiosInstance.get("/api/properties");
  return response.data;
};


export const getPropertiesById = async (id) => {
  const response = await AxiosInstance.get(`/api/properties/${id}`);
  return response.data;
};

// Create new user
export const GetFavorites = async () => {
  const response = await AxiosInstance.get("/api/favorites");
  return response.data;
};

export const removeFavorite = async ({ id }) => {
  const response = await AxiosInstance.post(`/api/favorites/${id}`);
  return response.data;
};

export const addFavorite = async () => {
  const response = await AxiosInstance.post(`/api/favorites`);
  return response.data;
};


export const getUser = async () => {
  const response = await AxiosInstance.get(`api/users/profile`);
  return response.data;
};

export const updateProfileImage = async (avatar) => {
  const response = await AxiosInstance.post(`api/users/uploadimage`, { avatar : avatar })
  return response.data;
};

export const editPhone = async (phone) => {
  const response = await AxiosInstance.put(`api/users/update`, { phone : phone })
  return response.data;
};

export const removeProfile = async (phone) => {
  const response = await AxiosInstance.get(`api/users/remove`)
  return response.data;
};

export const uploadProfile = async (formData) => {
  const response = await AxiosInstance.post(`/api/upload/`, formData,{headers: {
    'Content-Type': 'multipart/form-data',
  }}
  )
  return response.data;
};



export const addReviews = async (propertyId, rating, comment) => {
  const response = await AxiosInstance.post(`api/properties/${propertyId}/reviews`, { rating, comment });
  return response.data;
};





